import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'XML document',
      title: 'Get XML document',
      executeAction: 'Submit',
      errorMessage: 'Error',
    }
  }
}